"use client";

import { useEffect, useRef, useState } from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SeamlessAirportTransfers() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [scrollY, setScrollY] = useState(0);
  const heroRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (heroRef.current) {
        const rect = heroRef.current.getBoundingClientRect();
        const offset = window.innerHeight - rect.top;
        setScrollY(offset * 0.15);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://book.mylimobiz.com/v4/widgets/widget-loader.js";
    script.async = true;
    document.body.appendChild(script);
    return () => {
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);
  return <section ref={sectionRef} className="relative min-h-screen w-full overflow-hidden bg-secondary">
      {}
      <div ref={heroRef} className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1431253/img/airport_terminal_dusk_luxury_sedan.png)]" style={{
      transform: `translateY(${scrollY}px)`,
      transition: "transform 0.2s ease-out"
    }} />

      {}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-primary/30 to-primary/70" />

      {}
      <div className="relative z-10 flex min-h-screen items-center justify-center px-6 py-20">
        <div className="max-w-4xl text-center">
          {}
          <h1 className={`font-display text-4xl font-bold text-foreground-primary md:text-5xl lg:text-6xl transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: "0.2s"
        }}>
            Seamless Airport Transfers
          </h1>

          {}
          <p className={`mt-6 text-lg text-foreground-primary/90 md:text-xl font-sans transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: "0.4s"
        }}>
            Experience premium car service with Car Service Connecticut
          </p>

          {}
          <div className={`mt-10 transition-all duration-[var(--duration-slow)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`} style={{
          transitionDelay: "0.6s"
        }}>
            <Link to="https://book.mylimobiz.com/v4/CSC" data-ores-widget="website" data-ores-alias="CSC" className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-lg bg-accent text-foreground-accent px-8 py-4 text-base md:text-lg font-semibold shadow-strong hover:bg-accent-hover hover:shadow-medium hover:-translate-y-0.5 hover:scale-105 active:bg-accent-active active:translate-y-0 active:scale-100 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]">
              Online Reservations
            </Link>
          </div>
        </div>
      </div>
    </section>;
}